import { CommonConstant } from "../constants/common.constant";
import { saveAs } from "file-saver";

type LogLevel = 'log' | 'error' | 'warn' | 'info';

const consoleLogger = (
  message: string, 
  data?: unknown, 
  level: LogLevel = 'log'
): void => {
  if (process.env.ENVIRONMENT === CommonConstant.localEnvironemt) {
    console[level](message, data);
  }
};

const exportToCSV = (
  jsonData: any,
  fileName: string,
  sheetName?: string,
  headersRow?: any,
  keysWhichNeedsTobeFilteredFromJSON?: any
) => {
  const fileExtension = ".xlsx";
  var jsonObjectForExcelCreation = jsonData;

  if (keysWhichNeedsTobeFilteredFromJSON?.length > 0) {
    jsonObjectForExcelCreation = jsonObjectForExcelCreation.map((obj: any) =>
      Object.fromEntries(
        Object.entries(obj).filter(
          (r: any) => keysWhichNeedsTobeFilteredFromJSON?.indexOf(r[0]) > -1
        )
      )
    );
  }

  if (headersRow) {
    jsonObjectForExcelCreation.unshift(headersRow);
  }

  // Convert data to CSV format
  const csvContent = convertJSONToCSV(jsonObjectForExcelCreation);
  const blob = new Blob([csvContent], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  
  saveAs(blob, fileName + "-" + new Date().toISOString() + fileExtension);
};

const convertJSONToCSV = (data: any[], customHeaders?: string[]) => {
  if (!data || data.length === 0) return "";
  
  const keys = customHeaders || Object.keys(data[0]);
  const csvRows = [];
  
  // Add header row
  csvRows.push(keys.join(","));
  
  // Add data rows
  for (const row of data) {
    if (typeof row === 'object' && row !== null) {
      const values = keys.map(key => {
        const value = row[key];
        return formatCSVValue(value);
      });
      csvRows.push(values.join(","));
    }
  }
  
  return csvRows.join("\n");
};

const formatCSVValue = (value: any): string => {
  if (value === null || value === undefined) return "";
  
  const stringValue = String(value);
  
  // Handle values that contain commas, quotes, or newlines
  if (stringValue.includes(",") || stringValue.includes('"') || stringValue.includes("\n")) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  
  return stringValue;
};

const Helpers = {
  exportToCSV,
  convertJSONToCSV,
  formatCSVValue,
  consoleLogger,
};

export default Helpers;
